import {
  get
} from 'helpers/util'
import {
  lastItem
} from 'helpers/lastItem'

export const sortData = (chain, order, value) => {
  return (a, b) => {
    let vala = get([a, ...chain], null)
    let valb = get([b, ...chain], null)

    vala = Array.isArray(vala) ? lastItem(vala.map(val => val.score)) : vala
    valb = Array.isArray(valb) ? lastItem(valb.map(val => val.score)) : valb

    vala = value === 'Generated Date' ? new Date(vala) : vala
    valb = value === 'Generated Date' ? new Date(valb) : valb

    const sortBy = value === 'A-Z' || value === 'Sort by'

    switch (true) {
      case vala === null:
        return 1
      case valb === null:
        return -1
      case !sortBy && order === 'ascending':
        return vala - valb
      case !sortBy && order === 'descending':
        return valb - vala
      case vala > valb && order === 'ascending':
        return 1
      case vala < valb && order === 'ascending':
        return -1
      case vala < valb && order === 'descending':
        return 1
      case vala > valb && order === 'descending':
        return -1
      default:
        return vala
    }
  }
}

export function sortPosition(a, b, columnId, descending) {
  const valA = a.values[columnId]
  const valB = b.values[columnId]
  if (valA === '-') return descending ? -1 : 1
  if (valB === '-') return descending ? 1 : -1
  return valA - valB
}

export function sortValue(a, b, columnId, descending) {
  const valA = a.values[columnId]
  const valB = b.values[columnId]
  if (valA === '-') return descending ? -1 : 1
  if (valB === '-') return descending ? 1 : -1
  return valB - valA
}
